/**
 * Utility function to handle infinite scroll functionality for b-table component
 * Triggers callback when user scrolls near bottom of table and condition is met
 *
 * @param {Event} event - Scroll event from b-table
 * @param {boolean} condition - Additional condition that must be met to trigger callback (e.g. !loading && !lastData)
 * @param {Function} callback - Function to call when scroll threshold is reached (e.g. to fetch more data)
 */
// eslint-disable-next-line import/prefer-default-export
export const handleInfiniteScrollBTable = (event, condition, callback) => {
  const { target: { scrollTop, scrollHeight, clientHeight } } = event
  if (scrollHeight - (scrollTop + clientHeight) < 50 && (condition)) {
    callback()
  }
}
